import { MinusCircleOutlined } from '@ant-design/icons'
import {
  TraceKey,
  TraceKeyResponseTypeEnum,
} from '@ulysses-inc/harami_api_client'
import { Button, Dropdown, Flex, Typography } from 'antd'
import DateIcon from 'src/assets/icons/date.svg?react'
import MultipleChoiceSetIcon from 'src/assets/icons/multiple_choice_set.svg?react'
import TextIcon from 'src/assets/icons/text.svg?react'
import { ReportListFiltersDrawerFieldset } from 'src/features/reports/listBetaFilters/drawer/ReportListFiltersDrawerFieldset'
import { TraceKeyConditionFilter } from 'src/features/reports/listBetaFilters/drawer/hooks/useTraceKeyFilter'
import { DateTraceKeyFilter } from 'src/features/reports/listBetaFilters/drawer/tracekey/components/DateTraceKeyFilter'
import { ResponseSetTraceKeyFilter } from 'src/features/reports/listBetaFilters/drawer/tracekey/components/ResponseSetTraceKeyFilter'
import { TextTraceKeyFilter } from 'src/features/reports/listBetaFilters/drawer/tracekey/components/TextTraceKeyFilter'
const { Text } = Typography

type Props = {
  traceKeyConditionFilters: TraceKeyConditionFilter[]
  availableTraceKeys: TraceKey[]
  addTraceKeyConditionFilter: (traceKey: TraceKey) => void
  removeTraceKeyConditionFilter: (filter: TraceKeyConditionFilter) => void
  updateTraceKeyConditionFilter: (newFilter: TraceKeyConditionFilter) => void
  validatedTraceKeyIds: Set<number>
}
export const ReportListFiltersTraceKey = ({
  traceKeyConditionFilters,
  availableTraceKeys,
  addTraceKeyConditionFilter,
  removeTraceKeyConditionFilter,
  updateTraceKeyConditionFilter,
  validatedTraceKeyIds,
}: Props) => {
  return (
    <ReportListFiltersDrawerFieldset title="検索キー">
      <Flex vertical gap={8}>
        {traceKeyConditionFilters.length > 0 && (
          <Flex vertical gap={16}>
            {traceKeyConditionFilters.map(filter => (
              <TraceKeyConditionFilterInputItem
                key={filter.traceKeyId}
                filter={filter}
                onRemove={removeTraceKeyConditionFilter}
                onChange={updateTraceKeyConditionFilter}
                showError={validatedTraceKeyIds.has(filter.traceKeyId)}
              />
            ))}
          </Flex>
        )}

        <AddTraceKeyConditionFilterButton
          availableTraceKeys={availableTraceKeys}
          onAddTraceKeyConditionFilter={addTraceKeyConditionFilter}
        />
      </Flex>
    </ReportListFiltersDrawerFieldset>
  )
}

const TraceKeyConditionFilterInputItem = ({
  filter,
  onRemove,
  onChange,
  showError,
}: {
  filter: TraceKeyConditionFilter
  onRemove: (filter: TraceKeyConditionFilter) => void
  onChange: (newFilter: TraceKeyConditionFilter) => void
  showError: boolean
}) => {
  return (
    <Flex vertical gap={8}>
      <Flex align="center" justify="space-between">
        <Flex align="center" gap={8}>
          {filter.responseType === TraceKeyResponseTypeEnum.ResponseSet && (
            <MultipleChoiceSetIcon style={{ width: 24, height: 24 }} />
          )}
          {filter.responseType === TraceKeyResponseTypeEnum.Date && (
            <DateIcon style={{ width: 24, height: 24 }} />
          )}
          {filter.responseType === TraceKeyResponseTypeEnum.Text && (
            <TextIcon style={{ width: 24, height: 24 }} />
          )}
          <Text strong>{filter.traceKeyName}</Text>
        </Flex>
        <Button
          type="text"
          icon={<MinusCircleOutlined style={{ fontSize: 12 }} />}
          size="small"
          onClick={() => onRemove(filter)}
          title="検索キーを削除"
          style={{ color: '#999' }}
        />
      </Flex>
      {filter.responseType === TraceKeyResponseTypeEnum.ResponseSet && (
        <ResponseSetTraceKeyFilter
          filter={filter}
          onChange={onChange}
          showError={showError}
        />
      )}
      {filter.responseType === TraceKeyResponseTypeEnum.Date && (
        <DateTraceKeyFilter
          filter={filter}
          onChange={onChange}
          showError={showError}
        />
      )}
      {filter.responseType === TraceKeyResponseTypeEnum.Text && (
        <TextTraceKeyFilter
          filter={filter}
          onChange={onChange}
          showError={showError}
        />
      )}
    </Flex>
  )
}

const AddTraceKeyConditionFilterButton = ({
  availableTraceKeys,
  onAddTraceKeyConditionFilter,
}: {
  availableTraceKeys: TraceKey[]
  onAddTraceKeyConditionFilter: (traceKey: TraceKey) => void
}) => {
  const menuItems = availableTraceKeys.map(traceKey => ({
    key: traceKey.name,
    label: (
      <Flex align="center" gap={8} style={{ width: 320 }}>
        {traceKey.responseType === TraceKeyResponseTypeEnum.ResponseSet && (
          <MultipleChoiceSetIcon style={{ width: 16, height: 16 }} />
        )}
        {traceKey.responseType === TraceKeyResponseTypeEnum.Date && (
          <DateIcon style={{ width: 16, height: 16 }} />
        )}
        {traceKey.responseType === TraceKeyResponseTypeEnum.Text && (
          <TextIcon style={{ width: 16, height: 16 }} />
        )}
        {traceKey.name}
      </Flex>
    ),
    onClick: () => onAddTraceKeyConditionFilter(traceKey),
  }))

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      disabled={availableTraceKeys.length === 0}
    >
      <Button
        type="link"
        style={{
          width: '40%',
        }}
      >
        + 検索キーを追加
      </Button>
    </Dropdown>
  )
}
